const months = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const labelFormatter = (label: any, data: any) => {
  const month = data?.[0]?.payload?.month;
  const newLabel = typeof month === 'number' ? months[month - 1] : label;
  return newLabel;
};

export const formatter = (value: any) => {
  if (typeof value === 'number') {
    return value.toFixed(1).replace('.', ',');
  }

  return value;
};
